import React from 'react';
import PropTypes from 'prop-types';
import _fp from 'lodash/fp';
// import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import RouteCollection from '@bd/bdcore-named-routes';
import { Slugify } from '@bd/bdcore-utilities';

import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';
import MenuGallery from '../../components/MenuGallery';
import PhotoCategories from './PhotoCategories';

class ImageGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    const { page, router, plans } = this.props;
    const route = RouteCollection.getRouteByPath(_fp.get('location.pathname', router));
    const gallerySlug = _fp.get('params.category', route);
    const photos = _fp.flow([
      _fp.filter(item => (!gallerySlug || Slugify(item.name) === gallerySlug)),
      _fp.map('photos'),
      _fp.filter(Boolean),
      _fp.flatten,
    ])(_fp.get('galleries', page));

    const mycategories = _fp.flow([
      _fp.map('name'),
      _fp.uniq,
      _fp.filter(cat => gallerySlug === Slugify(cat)),
    ])(_fp.get('galleries', page));
    return (
      <PageWrapper>
        <PageHelmet
          custom
          title={`${mycategories} Photo Gallery`}
        />
        <InsideHeader
          h1={`${page.metaTags.title}`}
          background={_fp.get('page_image', page)}
        />
        <MenuGallery />
        <PhotoCategories page={page} gallerySlug={gallerySlug} />
        <LightBoxPhotoList
          show={12}
          photos={photos}
          plans={plans}
        />
      </PageWrapper>
    );
  }
}

ImageGallery.propTypes = {
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    page: 'image_gallery',
    router: true,
    plans: true,
  },
  {
    required: {
      page: true,
      router: true,
      plans: true,
    },
    ifMissing404: true,
  },
)(ImageGallery);



// WEBPACK FOOTER //
// ./src/pages/ImageGallery/index.js